import { ReactNode } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { AuthenticatedGuard } from "./AuthenticatedGuard";
import { RouteDefinition } from "./RouteDefinition";
import { RoutePolicy } from "./RoutePolicy";
import { UnauthenticatedGuard } from "./UnauthenticatedGuard";

export type RouterProps = {
  routes: RouteDefinition[];
  children?: ReactNode;
};

export const Router = (props: RouterProps) => {
  const { routes, children } = props;

  const getRouteElement = (route: RouteDefinition) => {
    if (route.policy === RoutePolicy.ForAuthenticated)
      return <AuthenticatedGuard>{route.element}</AuthenticatedGuard>;
    if (route.policy === RoutePolicy.ForGuests)
      return <UnauthenticatedGuard>{route.element}</UnauthenticatedGuard>;

    return route.element;
  };

  const routesWithGuard = routes.map((route) => {
    return {
      ...route,
      element: getRouteElement(route),
    };
  });

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: (
          <>
            <Outlet />
            {children}
          </>
        ),
        children: routesWithGuard,
        errorElement: <>Unexpected Error</>,
      },
      {
        path: "*",
        element: (
          <AuthenticatedGuard>
            <>Page not found</>
          </AuthenticatedGuard>
        ),
      },
    ],
    {
      future: {
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
      },
    },
  );

  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
};
